import React, { useEffect, useState } from 'react';
import { useFileExplorerDragContext } from './Context/FileExplorerDndContext';
import { MoveItemsModal } from './Modals/MoveFileModal';

export function FileExplorerMoveModal() {
  const { droppedItems, targetFolder, clearDropState } = useFileExplorerDragContext();
  const [showModal, setShowModal] = useState(false);

  useEffect(() => {
    if (droppedItems.length > 0 && targetFolder) {
      setShowModal(true);
    }
  }, [droppedItems, targetFolder]);

  const handleClose = () => {
    setShowModal(false);
    clearDropState();
  };

  return (
    <MoveItemsModal
      show={showModal}
      onHide={handleClose}
      items={droppedItems}
      targetFolder={targetFolder}
    />
  );
}
